import { Model } from "@vuex-orm/core";
import config from "../configs/Media";

export default class Media extends Model {
  static get entity() {
    return "media";
  }
  static fields() {
    return {
      id: this.attr(null),
      filename: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      file_path: this.attr(null),
      url: this.attr(null),
      resolution_id: this.attr(null),
      meeting_has_resolution_id: this.attr(null),
      agency_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
